<youtube-player *ngIf="videoId" [videoId]="videoId" [playerVars]="playerConfig"></youtube-player>
